module.exports = __webpack_public_path__ + "img/hafra_no.991793e2.png";